import { render } from "./StatsEditor.vue?vue&type=template&id=23467ebb"
import script from "./StatsEditor.vue?vue&type=script&lang=ts"
export * from "./StatsEditor.vue?vue&type=script&lang=ts"

import "./StatsEditor.vue?vue&type=style&index=0&id=23467ebb&lang=scss"
script.render = render

export default script